import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useChangeBranchCodingProfile = () => {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const changeBranchCodingProfile = ({ guid, newProfile, onSuccess }) => {
    setLoading(true);
    axiosClient
      .put(`/Product/Branch/Codding/Manual/ChengeProfile`, {
        guid,
        newProfile,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`پروفایل با موفقیت تغییر کرد`, {
            variant: 'success',
          });
          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return { changeBranchCodingProfile, loading };
};

export default useChangeBranchCodingProfile;
